import { useDisclosure } from '@chakra-ui/react';

import Alert from 'ui/Alert';
import Link from 'ui/Link';

import DownloadDiagramModal from '../DownloadDiagramModal';

const DownloadPNGBanner: React.FC = () => {
  const disclosure = useDisclosure();
  return (
    <>
      <Alert
        title="Want to download a PNG image of this diagram?"
        status="info"
        size="sm"
        mb={0}
      >
        You can do that for free by clicking on{' '}
        <Link onClick={disclosure.onOpen} variant="subtle">
          File &gt; Download
        </Link>
        .
      </Alert>
      <DownloadDiagramModal {...disclosure} />
    </>
  );
};

export default DownloadPNGBanner;
